var _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDevolucaoNafil = function SvgDevolucaoNafil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 30.501,
    height: 30.501,
    viewBox: "0 0 8.07 8.07",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16.647 12.866h12.446v10.608H16.647z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M124.016 94.742a3.917 3.917 0 0 1-3.917 3.916 3.917 3.917 0 0 1-3.917-3.916 3.917 3.917 0 0 1 3.917-3.917 3.917 3.917 0 0 1 3.917 3.917z",
    style: {
      fill: "green",
      fillRule: "evenodd",
      stroke: "green",
      strokeWidth: 0.206879,
      strokeLinecap: "square",
      strokeMiterlimit: 3.1,
      paintOrder: "markers fill stroke"
    },
    transform: "translate(-116.064 -90.707)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.106 82.932 3.628 2.039-9.178 5.404-3.8-2.194zm5.062 2.994 4.065 2.148-9.25 5.33-3.8-2.193z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: ".264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-24.824 -21.512) scale(.27206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.268 93.96 9.375-5.36-.153 10.717-9.146 5.472zm-.572-.002-9.184-5.243.153 10.448 9.146 5.472z",
    style: {
      fill: "#fff",
      stroke: "#fff",
      strokeWidth: ".264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "translate(-24.824 -21.512) scale(.27206)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.46 90.821 1.305.743.014 2.887-.203-.364-.148.268-.158-.344-.206.275-.11-.344-.247.262-.11-.4-.18.372.028-3.41",
    style: {
      fill: "green",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 0.01,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-24.824 -21.512) scale(.27206)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: "5.33333px",
      lineHeight: 0.65,
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "center",
      letterSpacing: 0,
      wordSpacing: 0,
      whiteSpace: "pre",
      shapeInside: "url(#a)",
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.057 14.227 3.466 1.728v.176l-.384-.176h-3.082v-1.728zm0-.373 3.466 1.728v.187l-3.466-1.728v-.187zm0-.39 3.466 1.74v.191l-3.466-1.744v-.186zm0-.373 3.466 1.739v.187l-3.466-1.739v-.187zm0-.362 3.466 1.728v.186l-3.466-1.738v-.176zm0-.379 1.648.827v-.827h1.818v1.91l-3.466-1.723v-.187z",
    "aria-label": "N",
    style: {
      fontFamily: "Sinaloa-Normal",
      InkscapeFontSpecification: "Sinaloa-Normal",
      fill: "green"
    },
    transform: "matrix(.49239 -.30433 0 .49239 -5.82 4.789)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDevolucaoNafil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/devolucaoNafil.0d298643.svg";
export { ForwardRef as ReactComponent };